<template>
    <div class="menu_list_box">
        <div class="menu_item_" @click="goToPage('/home')">Home</div>

        <el-collapse>
            <el-collapse-item title="Services" name="Services">
                <div class="menu_item_" @click="goToPage('/recheck-ai')">ReCheck</div>
                <div class="menu_item_" @click="goToPage('/plugin')">Plugin</div>
                <div class="menu_item_" @click="goToPage('/ai')">AI</div>
            </el-collapse-item>
        </el-collapse>

        <div class="menu_item_" @click="goToPage('/team')">Team</div>

        <el-collapse>
            <el-collapse-item title="Community" name="Community">
                <div class="menu_item_" @click="goToPage('/partners')">Partners</div>
            </el-collapse-item>
        </el-collapse>

        <el-collapse>
            <el-collapse-item title="About us" name="About us">
                <div class="menu_item_" @click="goToPage('/metrics')">Metrics</div>
                <!-- <div class="menu_item_" @click="goToPage('/researchers')">Researchers</div>
                <div class="menu_item_" @click="goToPage('/regional-representatives')">Regional Representatives</div> -->
                <div class="menu_item_">News</div>
                <div class="menu_item_">Blogs</div>
            </el-collapse-item>
        </el-collapse>

        <el-collapse>
            <el-collapse-item title="Contact us" name="Contact us">
                <div class="menu_item_" @click="goToPage('/contact-us')">Contact us</div>
                <!-- <div class="menu_item_" @click="goToPage('/offices')">Offices</div> -->
                <div class="menu_item_" @click="goToPage('/join')">Join Contrimetric Family</div>
            </el-collapse-item>
        </el-collapse>

        <el-button type="primary" class="apply_btn" @click="goToRequestDemo">Request a
            Demo</el-button>
    </div>
</template>

<script>
import { validRoutes } from './userDefinedBanner/data';

export default {
    data() {
        return {
            validRoutes
        }
    },
    methods: {
        goToPage(page) {
            this.$emit('closeDrawer')
            if (validRoutes.includes(page)) return

            this.$router.push(page);
        },
        goToRequestDemo() {
            this.$emit('closeDrawer')
            setTimeout(() => {
                this.$emit('goToRequestDemo')
            }, 300);
        }
    }
}
</script>

<style lang='scss' scoped>
.menu_list_box {
    padding: 0 20px;
    padding-bottom: 20px;

    .el-collapse-item {
        .el-collapse-item__header {
            font-size: 16px;
            padding: 5px 0;
        }

        .el-collapse-item__content {
            .menu_item_ {
                margin-left: 20px;
            }
        }
    }

    .menu_item_ {
        font-size: 16px;
        padding: 20px 0;
    }

    .apply_btn {
        width: 100%;
        margin-top: 20px;
        text-align: center;
    }
}
</style>